import React from "react";
// import { X } from "react-feather"; // or use a plain ×
import { IoMdCloseCircleOutline } from "react-icons/io";

function Modal({ isOpen, onClose, children }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-sm w-full relative p-6">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
        >
          <IoMdCloseCircleOutline size={'20px'} />

        </button>
        {children}
      </div>
    </div>
  );
}

export default Modal;
